import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import {
    listClientsAction,
    startLoader,
    checkClientRegistrationFromClientAction
} from '../../../store/actions/ClientAuthActions';
import { getBeneficiairesAction, loadingToggleAction,loadingToggleActionStop } from "../../../store/actions/ContratActions";
import { Button, Spinner } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import {format} from 'date-fns';
import { currentUser } from '../../../store/selectors/CurrentUserSelector';
import { useTranslation } from "react-i18next";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button as PButton } from 'primereact/button';
import { DataTableBase } from "../DataTables/DataTableBase";


export const ClientSearch = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let data = useRef([]);
    const [searchNumPoliceValue, setSearchNumPoliceValue] = useState("");
    const [searchNomSouscripValue, setSearchNomSouscripValue] = useState("");
    const [searchNomBenefValue, setSearchNomBenefValue] = useState("");

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            numeroPolice: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            nomSouscripteur: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            lienParenteText: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            nom: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            sexe: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            dateNaissanceText: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        });
        setGlobalFilterValue("");
    };
    
    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                <PButton type="button" icon="pi pi-filter-slash" label={t('common.reinit')} outlined onClick={clearFilter} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder={t('common.search')} />
                </span>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const setColumns = () => {
        return [
            {name: 'numeroPolice', headerName: t('patient.contract-num'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'nomSouscripteur', headerName: t('patient.suscriber'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: null},
            {name: 'nom', headerName: t('common.name-firstname'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: null}, 
            {name: 'lienParenteText', headerName: t('common.lien-parente'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: null},   
            {name: 'sexe', headerName: t('common.gender'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: null},  
            {name: 'dateNaissanceText', headerName: t('common.birthdate'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: null},           
            {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '4rem'}, filter: false, bodyTemplate: getActionsTemplate},
        ]
    };

    const getActionsTemplate = (rowData) => {
        return <div style={{ width: '100%', display: 'flex', justifyContent: 'center'}}>
                <button className="btn btn-info shadow btn-xs sharp mr-2"
                    onClick={(e) => registerClient(rowData)}
                >
                    <i className="fa fa-pencil"></i>
                </button>
        </div>
    };
    
    useEffect(() => {
        initFilters();
        if(props.showContratLoading){
            dispatch(loadingToggleActionStop());
        }
    }, []);
    const searchAssure = (e) => {
        e.preventDefault();
        dispatch(loadingToggleAction());
        dispatch(getBeneficiairesAction(
            searchNomBenefValue.trim().length > 0 ? searchNomBenefValue : null, 
            searchNumPoliceValue.trim().length > 0 ? searchNumPoliceValue : null, 
            searchNomSouscripValue.trim().length > 0 ? searchNomSouscripValue : null));
        //dispatch(listClientsAction(searchValue));
    }


    const registerClient = (client) => {
        dispatch(startLoader());
        dispatch(checkClientRegistrationFromClientAction(client.id, props.history));
    }

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
          return false;
        }else{
          return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
      }
    
     const hasMenu = (menuCode) => {
          return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
      }

      useEffect(() => {
        if(hasMenu('MENENROLL') && canDo('MENENROLL', 'ACENRRF')){
        }else{
            props.history.push("/provider-view/"+props.currentUser.providerId);
        }
    }, []);

    return (
        <>
            { props.showContratLoading  && <div id="preloader">
                <div className="sk-three-bounce">
                    <div className="sk-child sk-bounce1"></div>
                    <div className="sk-child sk-bounce2"></div>
                    <div className="sk-child sk-bounce3"></div>
                </div>
            </div> }
            { !props.showContratLoading &&
            <>
            <p className="text-center">{t('patient.search-assured-enrol')}</p>
            <form onSubmit={searchAssure}>
                <div className="row justify-content-center">
                    <div className="col-lg-3 mb-2">
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('patient.police-number')}
                                value={searchNumPoliceValue}
                                onChange={(e) => setSearchNumPoliceValue(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('patient.subscriber-name')}
                                value={searchNomSouscripValue}
                                onChange={(e) => setSearchNomSouscripValue(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 mb-2">
                        <div className="form-group">
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('patient.beneficiary-name')}
                                value={searchNomBenefValue}
                                onChange={(e) => setSearchNomBenefValue(e.target.value)}
                            />
                        </div>
                    </div>
                    { props.showLoading && 
                        <div className='col-6'>
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />{' '}
                                <span className="visually-hidden">{t('common.await-text')}</span>
                            </Button> 
                        </div>}
                    { !props.showLoading &&
                        <div className='col-1'>
                            <button type='submit' className='btn btn-primary btn-block'>
                                <i className='la la-search'></i>
                            </button>
                        </div> }
                </div>
            </form>

            { !props.showLoading && props.clients.length > 0 && <div className="row">
                <div className="col-xl-12">
                    <DataTableBase 
                        data={props.clients.map(client => {
                            client.dateNaissanceText = format(new Date(client.dateNaissance), 'dd/MM/yyyy');
                            client.lienParenteText = client.lienParente === "E" ? "Enfant" : client.lienParente === "C" ? "Conjoint" : "Assuré Principal";
                            return client;
                        })}
                        emptyMessage={t('patient.no-result')}
                        filters={filters}
                        globalFiltersFields={['numeroPolice', 'nomSouscripteur', 'nom', 'sexe', 'dateNaissanceText']}
                        header={renderHeader()}
                        columns={setColumns()}
                        rows={10} 
                        loading={props.showLoading}
                    />
                </div>
            </div>}
            </>
            }
        </> 
    )
};

const mapStateToProps = (state) => {
    return {
        clients: state.contrat.beneficiaires,
        errorMessage: state.clientAuth.errorMessage,
        successMessage: state.clientAuth.successMessage,
        showLoading: state.clientAuth.showLoading,
        showContratLoading: state.contrat.showLoading,
        currentUser: currentUser(state)
    };
};

export default withRouter(connect(mapStateToProps)(ClientSearch));